export default {"src":"/_next/static/media/stepper-line.4c5130cd.svg","height":12,"width":11,"blurWidth":0,"blurHeight":0};